<!-- Estilos: src/assets/styles/components/_liga-ui.scss (.lx-*) y _liga-c.scss (.lxc-*). -->
<section class="lx-pagina" lang="es" [class.lx-pagina--con-cta]="conCtaFijo">
  <header class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-hero__icono" [class.lx-hero__icono--verde]="resultado === 'exito'" aria-hidden="true"><fa-icon [icon]="iconos.video"></fa-icon></span>
      <div class="lx-hero__textos">
        <span class="lx-hero__eyebrow">Tu videoselfie</span>
        <h2 class="lx-hero__titulo">{{tituloHero}}</h2>
        <p class="lx-hero__subtitulo">{{subtituloHero}}</p>
        <span class="lx-chip" *ngIf="data.comment && resultado !== 'exito'" [ngClass]="estados.corrige.chip">
          <fa-icon [icon]="estados.corrige.icono!" aria-hidden="true"></fa-icon>{{estados.corrige.texto}}
        </span>
      </div>
    </div>
    <div class="lx-hero__pie">
      <ol class="lx-etapas" [attr.aria-label]="'Parte ' + pasoActual + ' de 2'">
        <li [class.is-actual]="!hasFile" [class.is-listo]="hasFile" [attr.aria-current]="!hasFile ? 'step' : null">
          <span class="lx-etapas__barra" aria-hidden="true"></span>
          <span class="lx-etapas__texto"><span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="hasFile; else parteUno" [icon]="iconos.listo"></fa-icon><ng-template #parteUno>1</ng-template></span>Graba</span>
        </li>
        <li [class.is-actual]="hasFile && resultado !== 'exito'" [class.is-listo]="resultado === 'exito'" [attr.aria-current]="hasFile && resultado !== 'exito' ? 'step' : null">
          <span class="lx-etapas__barra" aria-hidden="true"></span>
          <span class="lx-etapas__texto"><span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="resultado === 'exito'; else parteDos" [icon]="iconos.listo"></fa-icon><ng-template #parteDos>2</ng-template></span>Revisa y envía</span>
        </li>
      </ol>
    </div>
  </header>

  <!-- ===== Enviado ===== -->
  <div class="lx-celebracion" *ngIf="resultado === 'exito'; else flujo">
    <div class="lx-celebracion__check">
      <svg class="lx-check" viewBox="0 0 52 52" aria-hidden="true">
        <circle class="lx-check__circulo" cx="26" cy="26" r="25"></circle>
        <path class="lx-check__trazo" d="M15 27.5l7 7 15-16"></path>
      </svg>
    </div>
    <h3 class="lx-celebracion__titulo">¡Listo! Recibimos tu videoselfie</h3>
    <p class="lx-celebracion__msg" *ngIf="responseMessage[0]?.summary as msg" role="status">{{msg}}</p>
    <button type="button" class="lx-btn lx-btn--primario" (click)="terminar()"><span>Continuar</span></button>
    <p class="lx-celebracion__nota">Te regresamos a tus pasos en unos segundos.</p>
  </div>

  <ng-template #flujo>
    <div class="lx-alerta lx-alerta--error" *ngIf="data.comment">
      <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
      <div class="lx-alerta__cuerpo">
        <p class="lx-alerta__titulo">Necesitamos que grabes otro video</p>
        <p class="lx-alerta__texto">Motivo: <strong>{{data.comment}}</strong></p>
      </div>
    </div>

    <div class="lx-alerta lx-alerta--aviso" *ngIf="avisoArchivo" role="alert">
      <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.aviso"></fa-icon></span>
      <p class="lx-alerta__texto lx-alerta__cuerpo">{{avisoArchivo}}</p>
      <button type="button" class="lx-alerta__cerrar" aria-label="Cerrar aviso" (click)="avisoArchivo = ''"><fa-icon [icon]="iconos.cerrar"></fa-icon></button>
    </div>

    <!-- ===== Paso 1 de 2: preparar y grabar ===== -->
    <ng-container *ngIf="!hasFile; else revisar">
      <div class="lx-tarjeta">
        <div class="lx-tarjeta__cabeza">
          <div>
            <h3 class="lx-tarjeta__titulo">Lo que vas a decir</h3>
            <p class="lx-tarjeta__subtitulo">Léela completa y di tu nombre donde está marcado.</p>
          </div>
        </div>
        <blockquote class="lxc-guion">
          Yo, <span class="lxc-guion__nombre">tu nombre completo</span>, por este medio confirmo que fui informado y estoy de acuerdo en que, en caso de separarme de la empresa, cualquier cantidad que me corresponda por concepto de finiquito, liquidación o compensación económica será aplicada al saldo pendiente de mi crédito. También me comprometo a continuar con los pagos en caso de que dicho saldo no quede totalmente cubierto.
        </blockquote>
      </div>

      <div class="lx-tarjeta">
        <h3 class="lx-tarjeta__titulo">Para que salga a la primera</h3>
        <ul class="lxc-consejos" style="margin-top: 12px">
          <li class="lxc-consejo" *ngFor="let consejo of consejos">
            <span class="lxc-consejo__icono" aria-hidden="true"><fa-icon [icon]="consejo.icono"></fa-icon></span>
            <span class="lxc-consejo__texto">{{consejo.texto}}</span>
          </li>
        </ul>
      </div>

      <div class="lx-tarjeta">
        <h3 class="lx-tarjeta__titulo">¿Ya lo grabaste?</h3>
        <p class="lx-tarjeta__subtitulo">Elige el video desde tu galería. MP4, MOV o WebM.</p>
        <div class="lx-cta" style="margin-top: 12px">
          <button type="button" class="lx-btn lx-btn--secundario" (click)="inputGaleria.click()">
            <fa-icon [icon]="iconos.galeria" aria-hidden="true"></fa-icon><span>Elegir de mi galería</span>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- ===== Paso 2 de 2: revisar y enviar ===== -->
    <ng-template #revisar>
      <div class="lx-tarjeta" [class.lx-tarjeta--error]="resultado === 'error'">
        <video class="lxc-video" *ngIf="vistaPrevia" [src]="vistaPrevia" controls playsinline preload="metadata"
               aria-label="Vista previa de tu videoselfie"></video>
        <div class="lxc-archivo">
          <span class="lxc-archivo__icono" aria-hidden="true"><fa-icon [icon]="iconos.pelicula"></fa-icon></span>
          <div class="lxc-archivo__info">
            <p class="lxc-archivo__nombre" [title]="file ? file.name : ''">{{file ? file.name : 'Tu video'}}</p>
            <p class="lxc-archivo__meta">{{tamanoArchivo}} · Video</p>
          </div>
          <button type="button" class="lx-icono-boton" aria-label="Quitar video" [disabled]="enviando" (click)="cambiarVideo()">
            <fa-icon [icon]="iconos.borrar"></fa-icon>
          </button>
        </div>

        <div class="lxc-avisos" aria-live="polite" style="margin-top: 14px">
          <div class="lx-alerta" *ngFor="let m of responseMessage; trackBy: porMensaje" [ngClass]="tono(m).clase" [attr.role]="tono(m).rol">
            <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="tono(m).icono"></fa-icon></span>
            <div class="lx-alerta__cuerpo">
              <p class="lx-alerta__titulo" *ngIf="m.severity === 'error'">No pudimos enviar tu video</p>
              <p class="lx-alerta__texto">{{m.summary}}</p>
            </div>
          </div>
        </div>

        <div class="lx-cta" style="margin-top: 8px">
          <button type="button" class="lx-btn lx-btn--texto" style="align-self: center" [disabled]="enviando"
                  (click)="cambiarVideo(); inputCamara.click()">
            <fa-icon [icon]="iconos.video" aria-hidden="true"></fa-icon><span>Grabar otro video</span>
          </button>
        </div>
      </div>
    </ng-template>

    <p class="lx-seguro">
      <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.seguro"></fa-icon></span>
      <span>Tu video se envía de forma segura y solo se usa para validar tu solicitud.</span>
    </p>
  </ng-template>
</section>

<!-- Entradas de archivo: cámara frontal (grabar) y galería. Ocultas: las abren los botones. -->
<input #inputCamara class="lx-sr lxc-input-camara" type="file" [accept]="tiposAceptados" capture="user"
       tabindex="-1" aria-hidden="true" (change)="alElegirVideo($event)">
<input #inputGaleria class="lx-sr lxc-input-galeria" type="file" [accept]="tiposAceptados"
       tabindex="-1" aria-hidden="true" (change)="alElegirVideo($event)">

<!-- CTA fijo (hermano de la página: ningún ancestro con animación ni transform) -->
<div class="lx-cta-fijo" *ngIf="conCtaFijo">
  <ng-container *ngIf="!hasFile; else ctaEnviar">
    <button type="button" class="lx-btn lx-btn--primario" (click)="inputCamara.click()">
      <fa-icon [icon]="iconos.video" aria-hidden="true"></fa-icon><span>Grabar mi video</span>
    </button>
    <p class="lx-cta-fijo__nota"><fa-icon [icon]="iconos.video" aria-hidden="true"></fa-icon>Se abre la cámara frontal de tu celular.</p>
  </ng-container>
  <ng-template #ctaEnviar>
    <button type="button" class="lx-btn lx-btn--primario" (click)="!enviando && save()"
            [class.is-cargando]="enviando" [attr.aria-busy]="enviando ? 'true' : null">
      <span class="lx-spinner" *ngIf="enviando" aria-hidden="true"></span>
      <fa-icon *ngIf="!enviando && resultado === 'error'" [icon]="iconos.reintentar" aria-hidden="true"></fa-icon>
      <span>{{enviando ? 'Enviando tu video…' : resultado === 'error' ? 'Reintentar envío' : 'Enviar mi video'}}</span>
    </button>
    <p class="lx-cta-fijo__nota"><fa-icon [icon]="iconos.seguro" aria-hidden="true"></fa-icon>{{enviando ? 'No cierres esta pantalla.' : 'Revisa que se vea y se escuche bien.'}}</p>
  </ng-template>
</div>
